import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';

export class GridStateCompositeFilterDescriptor
  implements CompositeFilterDescriptor
{
  logic: 'or' | 'and';
  filters: (CompositeFilterDescriptor | FilterDescriptor)[];
  constructor(filter?: CompositeFilterDescriptor) {
    this.logic = filter?.logic || 'and';
    this.filters = filter?.filters || [];
  }
  or(
    otherFilterDescriptor: CompositeFilterDescriptor | FilterDescriptor,
  ): GridStateCompositeFilterDescriptor {
    if (!otherFilterDescriptor) {
      return this;
    }
    if (this.filters.length === 0) {
      const result = new GridStateCompositeFilterDescriptor();
      result.filters = [otherFilterDescriptor];
      return result;
    }
    return new GridStateCompositeFilterDescriptor({
      logic: 'or',
      filters: [this, otherFilterDescriptor],
    });
  }

  and(
    otherFilterDescriptor: CompositeFilterDescriptor | FilterDescriptor,
  ): GridStateCompositeFilterDescriptor {
    if (!otherFilterDescriptor) {
      return this;
    }
    if (this.filters.length === 0) {
      const result = new GridStateCompositeFilterDescriptor();
      result.filters = [otherFilterDescriptor];
      return result;
    }

    return new GridStateCompositeFilterDescriptor({
      logic: 'and',
      filters: [this, otherFilterDescriptor],
    });
  }
}
